import { render, staticRenderFns } from "./Poll.vue?vue&type=template&id=1f525223&scoped=true&"
import script from "./Poll.vue?vue&type=script&lang=ts&"
export * from "./Poll.vue?vue&type=script&lang=ts&"
import style0 from "./Poll.vue?vue&type=style&index=0&id=1f525223&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f525223",
  null
  
)

export default component.exports